import { render, staticRenderFns } from "./cards.vue?vue&type=template&id=31e0c7fb&scoped=true&"
import script from "./cards.vue?vue&type=script&lang=js&"
export * from "./cards.vue?vue&type=script&lang=js&"
import style0 from "./cards.vue?vue&type=style&index=0&id=31e0c7fb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e0c7fb",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Cards: require('/app/components/cards.vue').default})
